import { render, staticRenderFns } from "./permitting-extra-fields.vue?vue&type=template&id=26f7a2f6"
import script from "./permitting-extra-fields.vue?vue&type=script&lang=js"
export * from "./permitting-extra-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports